import { toast } from '../components/Toasts';

/** Copy text to the clipboard and say so. */
export const copy = (text: string) => void navigator.clipboard.writeText(text).then(() => toast('Copied'));
